<div class="sk-container" [ngClass]="{ 'sk-loading': state.loading }">
    <outlet-status [state]="state">
        <request-error (reloadFn)="reloadComponent()"></request-error>
    </outlet-status>
    @if (!state.loading && !state.error) {
        @if (racingName === 'horseracing') {
            <horseracing-tabs
                [applyingParams]="applyingParams"
                [viewByFilters]="viewByFilters"
                [filter]="filter"
                [isRacingPanel]="isRacingPanel"
                [tabsTitle]="tabsTitle"
                [sportName]="racingName"
                [racingPath]="racingPath"
                [display]="display"
                [sportModule]="sportModule"
                [responseError]="state.error"
                [isRunnersNumber]="isRunnersNumber"
                [racing]="racing"
                [racingSpecials]="racingYourCallSpecials"
                [expanded]="expanded"
                [sectionTitle]="sectionTitle"
                [isFavourite]="isFavourite"
                [definePriceType]="definePriceType"
                [goTo]="goTo"
                [outcomesLimit]="outcomesLimit"
                [getDay]="getDay"
                [getDate]="getDate"
                [getMonth]="getMonth"
                [eventsOrder]="eventsOrder"
                [categoryId]="categoryId"
                [isFromOverlay]="isEventOverlay"
                (isLoadedEvent)="updateLoadStatus($event)"
                data-crlat="tabContent">
            </horseracing-tabs>
        }
        @if (racingName === 'greyhound') {
            <greyhounds-tabs
                [applyingParams]="applyingParams"
                [viewByFilters]="viewByFilters"
                [filter]="filter"
                [isRacingPanel]="isRacingPanel"
                [tabsTitle]="tabsTitle"
                [sportName]="racingName"
                [racingPath]="racingPath"
                [display]="display"
                [sportModule]="sportModule"
                [responseError]="state.error"
                [isRunnersNumber]="isRunnersNumber"
                [racing]="racing"
                [expanded]="expanded"
                [sectionTitle]="sectionTitle"
                [isFavourite]="isFavourite"
                [definePriceType]="definePriceType"
                [goTo]="goTo"
                [getDay]="getDay"
                [getDate]="getDate"
                [getMonth]="getMonth"
                [eventsOrder]="eventsOrder"
                [categoryId]="categoryId"
                (isLoadedEvent)="updateLoadStatus($event)"
                [isEventOverlay]="isEventOverlay"
                data-crlat="tabContent">
            </greyhounds-tabs>
        }
    }
</div>
